module.exports = __webpack_public_path__ + "static/media/2.fca31183.jpg";